import { Type } from '@sinclair/typebox';
import { AttributesSchema } from "./shared.mjs";
export var ProductTemplateStatus;
(function (ProductTemplateStatus) {
    ProductTemplateStatus["Active"] = "active";
    ProductTemplateStatus["Draft"] = "draft";
    ProductTemplateStatus["Inactive"] = "inactive";
})(ProductTemplateStatus || (ProductTemplateStatus = {}));
export const ProductTemplateResponseSchema = Type.Object({
    id: Type.Number(),
    name: Type.String(),
    familyId: Type.Number(),
    sku: Type.String(),
    attributes: Type.Array(AttributesSchema),
    available: Type.Boolean(),
    status: Type.Enum(ProductTemplateStatus),
});
export const CreateProductTemplateSchema = Type.Omit(ProductTemplateResponseSchema, ['id']);
export const UpdateProductTemplateSchema = Type.Optional(CreateProductTemplateSchema);
//# sourceMappingURL=product-templates.js.map